import { fetchPost, fetchGet , fetchPut , fetchDelete} from '@/utils/request'

export function getDynamicModelList (query) {  //楼盘动态建模模板列表
    return fetchGet('/gateway/v1/house-trend-templates', query)
}
export function dynamicModelAdd (query) { //楼盘动态建模模板新增
    return fetchPost('/gateway/v1/house-trend-templates',query)
}
export function dynamicModelEdit (id,query) { //楼盘动态建模模板编辑
    return fetchPut('/gateway/v1/house-trend-templates/'+id,query)
}
export function getDynamicModelDetail (id) {  // 楼盘动态建模模板详情
    return fetchGet('/gateway/v1/house-trend-templates/'+id)
}
export function deleteDynamicModel (id) { //楼盘动态建模模板删除
    return fetchDelete('/gateway/v1/house-trend-templates/'+id)
}
export function dynamiCreateBySite (query) { //按站点创建动态
    return fetchPost('/gateway/v1/house-trend-templates/create-by-site',query)
}
export function dynamiCreateByHouse (query) { //按楼盘创建动态
    return fetchPost('/gateway/v1/house-trend-templates/create-by-house',query,{
        'Content-Type': 'multipart/form-data'
    })
}
export function dynamiTrendTplRecords (query) { //动态生成记录
    return fetchGet('/gateway/v1/house-trend-tpl-records',query)
}
export function trendTplRecordsDetail (query) { //动态生成记录详情列表
    return fetchGet('/gateway/v1/house-trend-tpl-record-details',query)
}
export function tplRecordstrends (query) { //生成动态列表
    return fetchGet('/gateway/v1/house-trend-tpl-record-trends',query)
}

export function getAdminHouseTrends (query) { //总站后台楼盘动态列表
    return fetchGet('/gateway/v1/admin-house-trends',query)
}
export function getHouseTrendsDetail (id,query) { //查询楼盘动态详情
    return fetchGet('/gateway/v1/house-trends/'+id+'/detail',query)
}
export function deleteHouseTrends (query) { //删除草稿箱楼盘动态
    return fetchDelete('/gateway/v1/delete-house-trends',query)
}
export function pushHouseTrends (query) { //发布草稿箱楼盘动态
    return fetchPut('/gateway/v1/push-house-trends',query)
}
export function editHouseTrends (id,query) { //编辑楼盘动态
    return fetchPut('/gateway/v1/house-trends/'+id,query)
}
export function getTrendsDynamicLabels (query) { //获取动态取值标签
    return fetchGet('/gateway/v1/trends-dynamic-labels',query)
}



